export const InputTypes = {
  Text: 'text',
  Password: 'password',
  Email: 'email',
  Number: 'number',
  Phone: 'tel',
};

export const InputPatterns = {
  Phone: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
  PostalCode: '^(?!.*[DFIOQU])[A-VXY][0-9][A-Z][0-9][A-Z][0-9]$',
};

export const InputPlaceholders = {
  Phone: '(555) 555-5555',
};

export const InputLengths = {
  PostalCode: 6,
  Phone: 16,
  Name: 255,
  Email: 255,
};

export const InputMasks = {
  PostalCode: 'A#A#A#',
};

export const InputEventType = {
  Change: 'change',
  Focus: 'focus',
  Blur: 'blur',
  Keydown: 'keydown',
  Keyup: 'keyup',
  AppendIconClick: 'append-icon-click',
  Keypress: 'keypress',
};

export const StyleFillType = {
  Outlined: 'outlined',
  Dashed: 'dashed',
  Underlined: 'underlined',
};

export const InputAutocompleteType = {
  Off: 'off',
  On: 'on',
};

export const InputCommonProperty = {
  Id: 'id',
  Name: 'name',
  Autocomplete: 'autocomplete',
  Value: 'value',
  Label: 'label',
  Type: 'type',
  Disabled: 'disabled',
  IsReadonly: 'isReadonly',
  Placeholder: 'placeholder',
};

export const InputValidationProperty = {
  IsShowErrorMessage: 'isShowErrorMessage',
  ErrorMessage: 'errorMessage',
  IsRequired: 'isRequired',
  Mask: 'mask',
  Pattern: 'pattern',
};

export const InputStyleProperty = {
  PrependIconType: 'prependIconType',
  ClassName: 'className',
  InputClassName: 'inputClassName',
  InputLabelClassName: 'inputLabelClassName',
  IconColor: 'iconColor',
  ColorScheme: 'colorScheme',
  IconSize: 'iconSize',
  LabelColorScheme: 'labelColorScheme',
  AppendIconType: 'appendIconType',
  FillType: 'fillType',
};

export const InputTextProperty = {
  MaxLength: 'maxLength',
  MinLength: 'minLength',
};

export const InputNumberProperty = {
  MaxNumber: 'maxNumber',
  MinNumber: 'minNumber',
  Step: 'step',
};

export const InputAutocompleteProperty = {
  Autocomplete: 'autocomplete',
};
